import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import BodyText from 'LuxKit/Typography/BodyText'

const StyledMessage = styled(BodyText)`
  white-space: nowrap;
`

interface Props {
  align?: 'start' | 'center' | 'end'
}

function MerchandiseMaxQuantityMessage({ align = 'end' }: Props) {
  const intl = useIntl()
  return (
    <StyledMessage variant="small" colour="neutral-three" align={align}>
      {intl.formatMessage({
        id: 'iGzBkNKs0aBP7TqZrW8U',
        defaultMessage: 'Maximum available quantity reached',
        description: 'Message shown when user reaches maximum available quantity',
      })}
    </StyledMessage>
  )
}

export default MerchandiseMaxQuantityMessage
